import axios from "axios";
import { server } from "../../server";

// Отримання всіх субсубкатегорій
export const getSubSubcategories = () => async (dispatch) => {
  try {
    dispatch({ type: "subsubcategoriesRequest" });
    const { data } = await axios.get(`${server}/subsubcategory/get-subsubcategories`);
    dispatch({ type: "subsubcategoriesSuccess", payload: data.subsubcategories });
  } catch (error) {
    dispatch({
      type: "subsubcategoriesFail",
      payload: error.response?.data?.message || "Failed to fetch subsubcategories",
    });
  }
};

// Створення субсубкатегорії
export const createSubSubcategory = (subsubcategoryData) => async (dispatch) => {
  try {
    dispatch({ type: "createSubSubcategoryRequest" });
    const { data } = await axios.post(
      `${server}/subsubcategory/create-subsubcategory`,
      subsubcategoryData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "createSubSubcategorySuccess", payload: data.subsubcategory });
  } catch (error) {
    dispatch({
      type: "createSubSubcategoryFail",
      payload: error.response?.data?.message || "Failed to create subsubcategory",
    });
  }
};

// Оновлення субсубкатегорії
export const updateSubSubcategory = (id, subsubcategoryData) => async (dispatch) => {
  try {
    dispatch({ type: "updateSubSubcategoryRequest" });
    const { data } = await axios.put(
      `${server}/subsubcategory/update-subsubcategory/${id}`,
      subsubcategoryData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "updateSubSubcategorySuccess", payload: data.subsubcategory });
  } catch (error) {
    dispatch({
      type: "updateSubSubcategoryFail",
      payload: error.response?.data?.message || "Failed to update subsubcategory",
    });
  }
};

// Видалення субсубкатегорії
export const deleteSubSubcategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteSubSubcategoryRequest" });
    await axios.delete(`${server}/subsubcategory/delete-subsubcategory/${id}`);
    dispatch({ type: "deleteSubSubcategorySuccess", payload: id });
  } catch (error) {
    dispatch({
      type: "deleteSubSubcategoryFail",
      payload: error.response?.data?.message || "Failed to delete subsubcategory",
    });
  }
};



// *** НОВЕ: Отримання продуктів за субсубкатегорією ***
export const getSubSubcategoryProducts = (id) => async (dispatch) => {
  try {
    dispatch({ type: "subSubcategoryProductsRequest" });
    const { data } = await axios.get(`${server}/subsubcategory/get-subsubcategory-products/${id}`);
    dispatch({ type: "subSubcategoryProductsSuccess", payload: data.products });
  } catch (error) {
    dispatch({
      type: "subSubcategoryProductsFail",
      payload: error.response?.data?.message || "Failed to fetch products by subsubcategory",
    });
  }
};